import { render, staticRenderFns } from "./VarModel.vue?vue&type=template&id=4601a080&scoped=true&"
import script from "./VarModel.vue?vue&type=script&lang=js&"
export * from "./VarModel.vue?vue&type=script&lang=js&"
import style0 from "./VarModel.vue?vue&type=style&index=0&id=4601a080&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4601a080",
  null
  
)

export default component.exports